module.exports = __webpack_public_path__ + "img/logo.f05e9f53.png";